import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'
import TokenStorage from '@/js/TokenStorage'
import SessaoRestResource from '@/components/sessao/SessaoRestResource'

Vue.use(Router)

const router = new Router({
  routes,
  mode: 'history'
})

router.beforeEach((routeTo, routeFrom, next) => {

  const authRequired = routeTo.matched.some(route => route.meta.authRequired)

  if (!authRequired) return next()

  const authToken = TokenStorage.loadAuthToken()

  if (authToken != null) {
    return SessaoRestResource.getSessao().then(sessao => {
      next()
    }).catch((err) => {
      redirectToLogin()
    })
  }

  redirectToLogin()

  function redirectToLogin() {
    next({ name: 'login', query: { redirectFrom: routeTo.fullPath } })
  }
})

export default router
